import { SettingsParser } from "./settings-parser";
import { SimpleVisualizatorSettings } from "../settings/simple-visualizator-settings";

export class SimpleSettingsParser extends SettingsParser {
  constructor() {
    super();
  }

  parse(settings, defaultSettings) {
    let parsedSettings = {};
    SettingsParser.parseRestFields(settings, defaultSettings, [], parsedSettings);
    return new SimpleVisualizatorSettings(parsedSettings);
  }
}
